import { IEntity } from "../interfaces/ientity";
import { IDisable } from "../interfaces/idisable";
import { MetadataType } from "../enums/metadatatype";

export abstract class Metadata implements IEntity, IDisable {
    $type: string;
    id: number;
    name: string;
    disabled: boolean;
    countries: MetaCountry[];
    metadataType: number;
    isEditable: boolean;
}

export class SourceMetadata extends Metadata {
    url: string;
    constructor() {
        super();
        this.$type = "MultiJurisdictionCms.Dto.Metadata.SourceMetadataDto, MultiJurisdictionCms.Dto";
        this.metadataType = MetadataType.Source;
    }
}

export class MetaCountry {
    countryId: number;
    isUsed: boolean;
}